export interface NavNode {
	display: string;
	path: string;
	activeClass: string;
	children?: NavNode[];
}

export const NAV_DATA: NavNode[] = [
	{
		display: 'Dashboard',
		path: '/home/dashboard',
		activeClass: 'active',
	},
	{
		display: 'Catalogs',
		path: '/catalogs',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Groups',
				path: '/catalogs/groups',
				activeClass: 'active',
			},
			{
				display: 'Exams',
				path: '/catalogs/exams',
				activeClass: 'active',
			},
			{
				display: 'Credentials',
				path: '/catalogs/credentials',
				activeClass: 'active',
			},
			{
				display: 'Other Requirements',
				path: '/catalogs/other-requirements',
				activeClass: 'active',
			},
			{
				display: 'Rebuilds',
				path: '/catalogs/rebuilds',
				activeClass: 'active',
			},
			{
				display: 'Linked Logic',
				path: '/catalogs/linked-logic',
				activeClass: 'active',
			},
			{
				display: 'Add Logic Version',
				path: '/catalogs/add-logic-version',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'Features',
		path: '/features',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Enable Features',
				path: '/features/enable',
				activeClass: 'active',
			},
			{
				display: 'Find Clients',
				path: '/features/clients',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'Localization',
		path: '/localization',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Hub Localizations',
				path: '/localization/hub',
				activeClass: 'active',
			},
			{
				display: 'Bulk Copy Localization',
				path: '/localization/bulk-copy',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'Imports',
		path: '/imports',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Dashboard',
				path: '/imports/dashboard',
				activeClass: 'active',
			},
			{
				display: 'Candidate Issues',
				path: '/imports/candidate-issues',
				activeClass: 'active',
			},
			{
				display: 'Exam Issues',
				path: '/imports/exam-issues',
				activeClass: 'active',
			},
			{
				display: 'Pending Exams',
				path: '/imports/pending-exams',
				activeClass: 'active',
			},
			{
				display: 'Other Requirement Issues',
				path: '/imports/other-requirement-issues',
				activeClass: 'active',
			},
			{
				display: 'Staging Statistics',
				path: '/imports/staging-statistics',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'Client Tools',
		path: '/client-tools',
		activeClass: 'has-children active',
		children: [
			{
				display: 'GDPR Reassignment',
				path: '/client-tools/gdpr',
				activeClass: 'active',
			},
			{
				display: 'Security Scripts',
				path: '/client-tools/security-scripts',
				activeClass: 'active',
			},
			{
				display: 'Exports',
				path: '/client-tools/exports',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'System',
		path: '/system',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Settings',
				path: '/system/settings',
				activeClass: 'active',
			},
			{
				display: 'Download Logic',
				path: '/system/download-logic',
				activeClass: 'active',
			},
		],
	},
	{
		display: 'Dev Stuff',
		path: '/dev',
		activeClass: 'has-children active',
		children: [
			{
				display: 'Table',
				path: '/dev/table',
				activeClass: 'active',
			},
			{
				display: 'Buttons',
				path: '/dev/buttons',
				activeClass: 'active',
			},
			{
				display: 'Forms',
				path: '/dev/forms',
				activeClass: 'active',
			},
			{
				display: 'HTML',
				path: '/dev/html',
				activeClass: 'active',
			},
		],
	},
];
